// Escapes a value for safe interpolation into HTML text or attribute content. pageConfig fields
// reach these callers from the shared-secret-gated /gp/ publish payload, not directly from
// end-user browser input — but they still get interpolated into HTML/attribute text, so escape
// defensively rather than trust the caller. Shared by every /gp/ render-time tag builder
// (seo-tags.js, prefetch-tags.js) rather than duplicated per-file, so a fix (e.g. a missing char
// class) lands everywhere at once.
const escapeHtml = (value)=>String(value).replace(/&/g, "&amp;").replace(/</g, "&lt;").replace(/>/g, "&gt;").replace(/"/g, "&quot;");
// Insert an HTML snippet at the end of a section — i.e. immediately before the given
// closing tag (e.g. "</head>" or "</body>"), making the snippet that section's last content.
// End-of-section is where injected scripts belong: body scripts must run after the DOM they
// read has been parsed, and head scripts should come after the page's own <meta> tags.
// The closing tag is matched case-insensitively, using its last occurrence. If the document
// has no such tag, `fallback(html, snippet)` decides where the snippet goes instead.
const insertBeforeClosingTag = (html, closingTag, snippet, fallback)=>{
    if (!snippet) return html;
    const idx = html.toLowerCase().lastIndexOf(closingTag);
    if (idx === -1) return fallback(html, snippet);
    return `${html.slice(0, idx)}${snippet}\n${html.slice(idx)}`;
};
module.exports = {
    escapeHtml,
    insertBeforeClosingTag
};
